<template>
	<button
		class="am-button-icon"
		:class="[
			`am-button-icon--${size}`
		]"
		@click="$emit('click', $event)"
	>
		<am-icon
			class="am-button-icon__icon"
			:size="size"
			:name="name"
		/>
	</button>
</template>

<script>
import AMIcon from '@/components/atoms/AMIcon'

export default {
	components: {
		'am-icon': AMIcon
	},

	props: {
		size: {
			type: String,
			default: 'sm' // sm | md
		},
		name: {
			type: String,
			default: 'chat'
		}
	}
}
</script>

<style lang="scss">
.am-button-icon{
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: white;
	border: 1px solid #99887F;
	border-radius: 999px;
	cursor: pointer;
	transition: .2s $easeInOutQuad;
	outline: none;
	&:hover{
		background: $c-light-brown;
		border-color: $c-light-brown;
		.am-button-icon{
			&__icon{
				color: white;
			}
		}
	}

	&__icon{
		transition: .2s $easeInOutQuad;
	}

	// Sizes
	&--sm{
		width: 44px;
		height: 44px;
	}
	&--md{
		width: 66px;
		height: 66px;
	}
}
</style>
